module.exports = __webpack_public_path__ + "img/core.83dd5056.png";